import { Select } from "ant-design-vue";
const { OptGroup, Option, ...other } = Select;
const YwSelect = {
  ...other,
  name: "YwSelect",
  OptGroup: {
    ...OptGroup,
    name: "YwSelectOptGroup",
  },
  Option: {
    ...Option,
    name: "YwSelectOption",
  },
};

YwSelect.install = function (Vue) {
  Vue.component(YwSelect.name, Select);
  Vue.component(YwSelect.OptGroup.name, OptGroup);
  Vue.component(YwSelect.Option.name, Option);
};

export default YwSelect;